module.exports = global["Modernizr"] = require("-!/app/node_modules/modernizr-loader/index.js!/app/node_modules/json-loader/index.js!./modernizrrc.json");